<template lang="pug">
  section#contact
    div( v-html="contact" )
</template>

<style lang="sass" scoped>
  section#contact
    display: flex
    align-items: center
    justify-content: center
    
    div
      margin: auto
      display: inline-block
      white-space: pre-wrap
</style>

<script>
  import { contact } from '../../config.js'

  export default {
    data () {
      return { contact }
    },
  }
</script>